<header class="app-header large-screen-header hide-on-mobile">
  <!-- Left Side: Search -->
  <div class="left-section">
    <li class="nav-item menu-bar d-block d-xl-none">
      <a class="nav-link sidebartoggler" (click)="toggleSidebar()">
        <i class="ti ti-menu-2"></i>
      </a>
    </li>
    <div class="current-date text-center">
      <i class="ti ti-calendar"></i> {{ currentDate | date:'fullDate' }} | {{ currentDate | date:'shortTime' }}
    </div>
    <!-- <div class="search-container">
      <i class="fa fa-search"></i>
      <input type="text" class="form-control" placeholder="Search by name">
    </div> -->
  </div>

  <!-- Right Side: Date + Controls -->
  <div class="right-section">
    
    <a *ngIf="constants.hasModulePermission('Scan_QR','LIST')" class="btn d-flex align-items-center gap-1 qr-button add-for-host"
      (click)="openScanner = true">
      <i class="bi bi-qr-code-scan" title="Scan QR code"></i>
    </a>

    <!--Reception/Security > Add Visit for Host -->
    <a *ngIf="constants.hasModulePermission('Create_Visit','ADD')" class="btn btn-primary d-flex align-items-center gap-1 add-visit-btn add-for-host" routerLink="/create-visit-by-reception">
      <img src="assets/icons/Add_Plus.png" alt="Add Visit"/>
      <span>Add Visit</span>
    </a>

    <!-- GTH-860: Send visit invite via WhatsApp, Email, or Copy Link | By Priya K, 07.08.2025 -->
    <div *ngIf="constants.hasModulePermission('Visit','ADD')">
      <div class="visit-invite-container d-flex align-items-center justify-content-center gap-4">

        <!-- <p class="text-center">Invitation Link</p> -->

        <!-- WhatsApp Button -->
        <button class="btn-icon shareVia-btn" title="Invite via WhatsApp" (click)="shareVia('whatsapp')">
          <i class="bi bi-whatsapp fs-5 text-success"></i>
        </button>
    
        <!-- Email Button -->
        <button class="btn-icon shareVia-btn" (click)="proceedToRequestDetails()" title="Invite via Email">
          <i class="bi bi-envelope fs-5 text-primary"></i>
        </button>
    
        <!-- Copy Link Option -->
        <div class="link-section d-flex justify-content-center align-items-center gap-2">
          <i *ngIf="!linkCopied" class="bi bi-copy fs-4 copy-icon" role="button" (click)="copyLink()"
            title="Copy Invite Link" style="padding-top: 2px; color:#00bfff"></i>
          <i *ngIf="linkCopied" class="bi bi-check-circle-fill fs-5 text-success" title="Copied!"></i>
        </div>
      </div>
    </div>
    <!-- //// End of Visit Invitation //// -->

    <a *ngIf="constants.hasModulePermission('Visit','ADD')"
      class="btn btn-primary d-flex align-items-center gap-1 add-visit-btn" routerLink="/create-visit">
      <img src="assets/icons/Add_Plus.png" alt="Add Visit" />
      <span>Add Visit</span>
    </a>
    <!-- Notification Icon -->
    <a *ngIf="constants.hasModulePermission('Notifications','LIST')" class="nav-link position-relative"
      data-notification-trigger (click)="toggleNotificationPanel();">
      <img src="assets/icons/mage_notification-bell.png" class="ti-bell cursor-pointer" alt="Notifications" />
      <span *ngIf="unreadCount > 0 && unreadCount <= 5" class="notification-count">{{ unreadCount }}</span>
      <span *ngIf="unreadCount > 5" class="notification-count notification-count-plus">5<span class="p-0 mb-0 notification-plus">+</span></span>
    </a>
    <!-- Notification Panel -->
    <div *ngIf="showNotifications" class="notification-panel">
      <div class="notification-header sticky-top bg-white">
        <h4 class="fw-bold mb-0">Notifications</h4>
        <button class="btn-close mb-2" (click)="showNotifications = false"></button>
      </div>

      <div class="notification-body">
        <div *ngIf="notifications.length > 0; else noNotifications">
          <div *ngFor="let notification of notifications" class="notification-item cursor-pointer"
            (click)="onNotificationClick(notification)">
            <strong class="p-1">🔔 {{ notification.title }}</strong>
            <p class="p-2 mb-0">{{ notification.message }}</p>
          </div>
        </div>
        <ng-template #noNotifications>
          <p class="text-muted text-center mt-3">You have no notifications.</p>
        </ng-template>
      </div>

      <div class="notification-footer sticky-bottom bg-white d-flex justify-content-between">
        <a class="fw-semibold text-link" *ngIf="notifications.length > 0" (click)="markAllAsRead()">Mark all as read</a>
        <a class="fw-semibold text-link text-end ms-auto" (click)="viewAllNotifications()">View All</a>
      </div>
    </div>

    <!-- Hi, User -->
    <div class="position-relative d-flex justify-content-center align-items-center">
      <p class="mb-0">Hi, {{ user?.firstName }}</p>
    </div>

    <!-- Role Section -->
    <div class="position-relative d-flex align-items-center">
      <img *ngIf="isReceptionOrSecurity(selectedRole)" src="assets/icons/iconamoon_profile_forReception.png" class="user-icon position-absolute me-2" alt="Profile" style="width: 24px;" />
      <img *ngIf="!isReceptionOrSecurity(selectedRole)" src="assets/icons/iconamoon_profile.png" class="user-icon position-absolute me-2" alt="Profile" />
      <select class="form-select form-select-sm text-muted" [(ngModel)]="selectedRole" (change)="onRoleChange($event)" 
      [ngClass]="{ 'reception-color': isReceptionOrSecurity(selectedRole) }">
        <option *ngFor="let r of roles" [ngValue]="r">{{ r.name }}</option>
      </select>
    </div>

  </div>
</header>

<!-- Mobile View Header -->
<header class="app-header mobile-header d-none d-xl-none" style="background-image: url('assets/images/headerbg.svg');">
  <div class="mobile-top">
    <!-- Left: Logo & Date Centered -->
    <div class="logo-date-section">
      <img src="assets/images/whitelogo.svg" alt="Logo" class="logo-image" />
      <p class="date-text">{{ currentDate | date: 'EEEE, d MMMM' }}</p>
    </div>

    <!-- Right: Notification & Profile -->
    <div class="icon-group">
      <!-- Notification Icon -->
      <a *ngIf="constants.hasModulePermission('Notifications','LIST')" class="nav-link position-relative cursor-pointer"
        data-notification-trigger (click)="toggleNotificationPanel()">
        <img src="assets/icons/mage_notification-bell.png" class="ti-bell cursor-pointer" alt="Notifications" />
        <span *ngIf="unreadCount > 0 && unreadCount <= 5" class="notification-count">{{ unreadCount }}</span>
        <span *ngIf="unreadCount > 5" class="notification-count notification-count-plus">5<span class="p-0 mb-0 notification-plus">+</span></span>
      </a>
      <!-- Notification Panel -->
      <div *ngIf="showNotifications" class="notification-panel">
        <div class="notification-header sticky-top bg-white">
          <h4 class="fw-bold mb-0">Notifications</h4>
          <button class="btn-close mb-2" (click)="showNotifications = false"></button>
        </div>

        <div class="notification-body">
          <div *ngIf="notifications.length > 0; else noNotifications">
            <div *ngFor="let notification of notifications" class="notification-item cursor-pointer"
              (click)="onNotificationClick(notification)">
              <strong class="p-1 cursor-pointer">🔔 {{ notification.title }}</strong>
              <p class="p-2 mb-0">{{ notification.message }}</p>
            </div>
          </div>
          <ng-template #noNotifications>
            <p class="text-muted text-center mt-3">You have no notifications.</p>
          </ng-template>
        </div>

        <div class="notification-footer sticky-bottom bg-white d-flex justify-content-between">
          <a class="fw-semibold text-link" *ngIf="notifications.length > 0" (click)="markAllAsRead()">Mark all as
            read</a>
          <a class="fw-semibold text-link text-end ms-auto" (click)="viewAllNotifications()">View All</a>
        </div>
      </div>
      <!-- <div class="profile-icon">
        <img [src]="user.photo || 'assets/images/profile/profile.png'" alt="Profile" />

      </div> -->
       <div class="profile-icon position-relative">
            <img [src]="profilePhoto || 'assets/images/profile/profile.svg'"
                alt="Profile" (click)="openRoleDropdown()" style="cursor: pointer;" />

            <select #roleDropdown class="form-select form-select-sm text-muted position-absolute"
                    [(ngModel)]="selectedRole"
                    (change)="onRoleChange($event)" [ngClass]="{ 'reception-color': isReceptionOrSecurity(selectedRole) }"
                    style="opacity: 0; position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
              <option *ngFor="let r of roles" [ngValue]="r">{{ r.name }}</option>
            </select>
        </div>

    </div>
  </div>
</header>

<!-- Tablet/Ipad View Header -->
<header class="app-header medium-screen-header">
  <div class="tab-top">
    <div class="d-flex gap-2">
      <a class="nav-link sidebartoggler d-flex align-items-center" (click)="toggleSidebar()">
        <img src="assets/icons/mi_menu.png" alt="Menu" class="menu-icon" />
      </a>
      <div class="title-section">
        <div class="d-flex justify-content-center"> 
          <img src="assets\images\VisitorBridgeLogo (1).png" alt="Logo" class="tab-logo" />
        </div>
        <p class="text-center mt-2 mb-0" style="font-size: 12px">{{ currentDate | date: 'EEEE, d MMMM' }}</p>
      </div>
    </div>
    
    <div class="header-icons">
      <a *ngIf="constants.hasModulePermission('Scan_QR','LIST')" class="btn d-flex align-items-center gap-1 qr-button add-for-host"
      (click)="openScanner = true">
      <i class="bi bi-qr-code-scan" title="Scan QR code"></i>
      </a>

      <!--Reception/Security > Add Visit for Host -->
      <a *ngIf="constants.hasModulePermission('Create_Visit','ADD')" class="btn btn-primary d-flex align-items-center gap-1 add-visit-btn add-for-host" routerLink="/create-visit-by-reception">
        <img src="assets/icons/Add_Plus.png" alt="Add Visit" />
        <span>Add Visit</span>
      </a>

      <!-- GTH-860: Send visit invite via WhatsApp, Email, or Copy Link | By Priya K, 07.08.2025 -->
      <div *ngIf="constants.hasModulePermission('Visit','ADD')">
        <div class="visit-invite-container d-flex align-items-center justify-content-center gap-4">
      
          <!-- <p class="text-center">Invitation Link</p> -->
      
          <!-- WhatsApp Button -->
          <button class="btn-icon shareVia-btn" title="Invite via WhatsApp" (click)="shareVia('whatsapp')">
            <i class="bi bi-whatsapp fs-5 text-success"></i>
          </button>
      
          <!-- Email Button -->
          <button class="btn-icon shareVia-btn" (click)="proceedToRequestDetails()" title="Invite via Email">
            <i class="bi bi-envelope fs-5 text-primary"></i>
          </button>
      
          <!-- Copy Link Option -->
          <div class="link-section d-flex justify-content-center align-items-center gap-2">
            <i *ngIf="!linkCopied" class="bi bi-copy fs-4 copy-icon" role="button" (click)="copyLink()"
              title="Copy Invite Link" style="padding-top: 2px; color:#00bfff"></i>
            <i *ngIf="linkCopied" class="bi bi-check-circle-fill fs-5 text-success" title="Copied!"></i>
          </div>
        </div>
      </div>
      <!-- //// End of Visit Invitation //// -->

      <a *ngIf="constants.hasModulePermission('Visit','ADD')" class="btn btn-primary d-flex align-items-center gap-1 add-visit-btn">
        <img src="assets/icons/Add_Plus.png" alt="Add Visit" routerLink="/create-visit" />
        <span>Add Visit</span>
      </a>
      <!-- Notification Icon -->
      <a *ngIf="constants.hasModulePermission('Notifications','LIST')" class="nav-link position-relative"
        data-notification-trigger (click)="toggleNotificationPanel()">
        <img src="assets/icons/mage_notification-bell.png" class="ti-bell cursor-pointer" alt="Notifications" />
        <span *ngIf="unreadCount > 0 && unreadCount <= 5" class="notification-count">{{ unreadCount }}</span>
        <span *ngIf="unreadCount > 5" class="notification-count notification-count-plus">5<span class="p-0 mb-0 notification-plus">+</span></span>      
      </a>
      <!-- Notification Panel -->
      <div *ngIf="showNotifications" class="notification-panel">
        <div class="notification-header sticky-top bg-white">
          <h4 class="fw-bold mb-0">Notifications</h4>
          <button class="btn-close mb-2" (click)="showNotifications = false"></button>
        </div>

        <div class="notification-body">
          <div *ngIf="notifications.length > 0; else noNotifications">
            <div *ngFor="let notification of notifications" class="notification-item cursor-pointer"
              (click)="onNotificationClick(notification)">
              <strong class="p-1">🔔 {{ notification.title }}</strong>
              <p class="p-2 mb-0">{{ notification.message }}</p>
            </div>
          </div>
          <ng-template #noNotifications>
            <p class="text-muted text-center mt-3">You have no notifications.</p>
          </ng-template>
        </div>

        <div class="notification-footer sticky-bottom bg-white d-flex justify-content-between">
          <a class="fw-semibold text-link" *ngIf="notifications.length > 0" (click)="markAllAsRead()">Mark all as
            read</a>
          <a class="fw-semibold text-link text-end ms-auto" (click)="viewAllNotifications()">View All</a>
        </div>
      </div>
      <!-- Hi, User -->
      <div class="position-relative d-flex justify-content-center align-items-center">
        <p class="mb-0">Hi, {{ user?.firstName }}</p>
      </div>
      <div class="icon-circle position-relative">
            <img *ngIf="isReceptionOrSecurity(selectedRole)" src="assets/icons/iconamoon_profile_forReception.png" style="width:25px;">
            <img *ngIf="!isReceptionOrSecurity(selectedRole)" src="assets/icons/mo-head-user-icon.png"
                alt="Profile" (click)="openRoleDropdown()" style="cursor: pointer;" />

            <select #roleDropdown class="form-select form-select-sm text-muted position-absolute"
                    [(ngModel)]="selectedRole"
                    (change)="onRoleChange($event)" [ngClass]="{ 'reception-color': isReceptionOrSecurity(selectedRole) }"
                    style="opacity: 0; position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
              <option *ngFor="let r of roles" [ngValue]="r">{{ r.name }}</option>
            </select>
      </div>

    </div>
  </div>
  <!-- <div class="search-container">
    <i class="fa fa-search"></i>
    <input type="text" class="form-control" placeholder="Search by name">
  </div> -->
</header>

<!-- GTH-860: Send visit invite via WhatsApp, Email, or Copy Link | By Priya K, 07.08.2025 -->
<div *ngIf="showRequestDetailsModal" class="main-modal">
  <div class="modal-main-content request-details-content rounded-4 p-2">
    <form #requestDetailsForm="ngForm" (ngSubmit)="requestDetailsForm.valid && requestDetails()" novalidate>
      <div class="modal-header-section align-items-center px-4 py-3 rounded-4 modal-lg">
        <h5 class="modal-heading mb-0">Invitation Details</h5>
        <button class="btn-close text-end" type="button" (click)="closeRequestDetailsModal()"></button>
      </div>

      <div class="modal-body d-flex flex-column justify-content-center px-4 py-4">
        
        <div class="row">
           <!-- Receiver Email -->
           <div class="col-md-12">
            <div class="form-group">
              <input type="email" id="receiverEmail" name="receiverEmail" class="form-control"
                [(ngModel)]="visitInvitation.receiverEmail" required pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                #receiverEmail="ngModel" placeholder="Receiver email"
                [ngClass]="{'is-invalid': receiverEmail.invalid && (receiverEmail.touched || requestDetailsForm.submitted)}">
              <div class="invalid-feedback"
                *ngIf="receiverEmail.invalid && (receiverEmail.touched|| requestDetailsForm.submitted)">
                <span *ngIf="receiverEmail.errors?.['required']">Email is required</span>
                <span *ngIf="receiverEmail.errors?.['pattern']">Please enter a valid email</span>
              </div>
            </div>
          </div>
         
        </div>
      </div>

      <div class="modal-footer gap-3 px-4 py-3 border-0">
        <button type="button" class="no-btn button-animations cancel-button" (click)="closeRequestDetailsModal()">Back</button>
        <button type="submit" class="yes-btn button-animations" [disabled]="formSubmitLoader2">
          <span *ngIf="formSubmitLoader2" class="spinner-border spinner-border-sm me-1" role="status"
          aria-hidden="true"></span>Send</button>
      </div>
    </form>
  </div>
</div>

<!-- Success Modal -->
<div *ngIf="showSuccessModal" class="success-modal-overlay">
  <div class="success-modal-content animate-success">
    <div class="success-icon">&#10004;</div>
    <p>Invitation sent successfully!</p>
  </div>
</div>
<!-- //// End of Visit Invitation //// -->


<app-qr-scanner *ngIf="openScanner" (scanned)="handleScan($event)" />